import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  primaryColor: {
    color: '#7833FF',
  },
  title: {
    color: '#D6246E',
  },
  backButton: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1.5, 3),
    textTransform: 'none',
    borderRadius: 40,
    backgroundColor: theme.palette.common.white,
    color: '#DC187F',
  },
  button: {
    padding: theme.spacing(1.5, 3),
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightBold,
    borderRadius: 40,
    fontSize: 18,
  },
  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(4),

    '& li:not(:first-child, :last-child) button': {
      color: '#5F29CC',
    },

    '& li button.Mui-selected, & li button.Mui-selected:hover': {
      color: `${theme.palette.common.white} !important`,
      backgroundColor: '#5F29CC',
    },
  },
}));
